<template>
  <Toast/>
  <DialogConfirmation ref="dialogConfirmation"/>
  <div class="row">
    <div class="col">
      <DataTable showGridlines
                 class="p-datatable-sm"
                 :value="interventions"
                 :resizableColumns="true"
                 columnResizeMode="fit"
                 :reorderableColumns="true"
                 dataKey="cleIntervention"
                 :paginator="true"
                 :rows="10"
                 sort-field="interventions"
                 :sortOrder="-1"
                 paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                 :rowsPerPageOptions="[10, 30, 100]"
                 currentPageReportTemplate="Afficher {first} de {last} sur {totalRecords} interventions"
      >
        <template #empty>
          <div v-if="isRechercheDataLoading == true" class="row">
            <div class="col">
              <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
            </div>
          </div>
          <div v-else class="row">
            &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
          </div>
        </template>
        <Column
            field="description"
            header="Description"
            :sortable="true"
        ></Column>
        <Column
            field="nom"
            header="Intervenant"
            :sortable="true"
        ></Column>
        <Column field="snSite" header="Site" :sortable="true">
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <Dropdown class="dropdown-height"
                          v-model="data[field]"
                          :options="snSiteLibelles"
                          optionValue="cle"
                          optionLabel="description"
                          scrollHeight="205px"
                          :showClear="true"/>
              </div>
            </div>
          </template>
        </Column>
        <Column field="courriel" header="Courriel" :sortable="true">
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <InputText v-model="data[field]"/>
              </div>
            </div>
          </template>
        </Column>
        <Column
            field="envoiSuivi"
            header="Envoi Suivi"
            :sortable="true"
        >
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <InputText v-model="data[field]"/>
              </div>
            </div>
          </template>
        </Column>
        <Column
            field="envoiMessage"
            header="Envoi Message"
            :sortable="true"
        >
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <InputText v-model="data[field]"/>
              </div>
            </div>
          </template>
        </Column>
        <Column
            field="texteSuivi"
            header="Texte Suivi"
            :sortable="true"
        >
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <InputText v-model="data[field]"/>
              </div>
            </div>
          </template>
        </Column>
        <Column
            field="texteMessage"
            header="Texte Message"
            :sortable="true"
        >
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <InputText v-model="data[field]"/>
              </div>
            </div>
          </template>
        </Column>
        <Column headerStyle="width: 8rem" :exportable="false">
          <template #body="slotProps">
            <div class="row">
              <div class="col">
                <Button
                    icon="pi pi-save"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="sauvegarder(slotProps.data)"
                />
              </div>
              <div class="col">
                <Button
                    icon="pi pi-trash"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="confirmerSuppression(slotProps.data)"
                />
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import axios from 'axios';
import DialogConfirmation from '../../Commun/DialogConfirmation.vue';

export default {
  props: ['interventions', 'isRechercheDataLoading'],
  emits: ['removeInterventionFromList'],
  components: {
    DialogConfirmation
  },
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store.dispatch('pilotage/obtenirSiteInterventionAction')
        .then((res) => {
          this.snSiteLibelles = res.data.sort((a, b) => {
            return this.$commun.compareString(a.description, b.description)
          });
        });
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      interventionToDelete: {},
      snSiteLibelles: [],
    }
  },
  methods: {
    confirmerSuppression(data) {
      this.interventionToDelete = data;
      this.$confirm.require({
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        message: "Voulez-vous supprimer la intervention?",
        accept: () => {
          return this.supprimer();
        },
        reject: () => {
        },
      })
    },
    supprimer() {
      this.$store.dispatch('pilotage/supprimerInterventionAction', {interventionVO: this.interventionToDelete})
          .then((res) => {
            if (res?.data?.messageVOs.length == 0) {
              this.$toast.add({
                severity: 'success',
                summary: 'Suppression Intervention',
                detail: "La suppression a été effectuée",
                life: 6000
              });
              this.$emit("removeInterventionFromList", this.interventionToDelete.cle, this.interventionToDelete.nom);
            } else {
              this.$root.$refs.messagesComp.messagesList = res.data.messageVOs;
            }
          });
    },
    sauvegarder(data) {
      this.$store.dispatch('pilotage/modifierInterventionAction', {interventionVO: data}).then(() => {
        this.$toast.add({
          severity: 'success',
          summary: 'Modification Intervention',
          detail: 'La modification a été effectuée',
          life: 6000
        });
      });
    },
  },
};
</script>
